<template>
    <div class="page_mobile_server flex-col">

        <div class="div_server_wrap flex-col">

            <div class="text-group_10 flex-col">
                <span class="text_35">服务优势</span>
                <span class="text_36">SERVICE&nbsp;ADVANTAGES</span>
            </div>
            <div class="div_server">

                <div class="block_content">
                    <div class="group_26 flex-col">
                        <div class="block_5 flex-col">
                            <div class="text-wrapper_4 flex-row">
                <span
                        v-for="(tab, index) in serviceAdvantages"
                        :key="index"
                        :ref="`tab-${index}`"
                        :class="activeTab === index ? 'text_active':'text_38'"
                        @click="selectFun(index)"
                        @mouseover="hoverIndexFun(index)"
                        @mouseout="hoverOff"
                >{{tab.title}}</span>
                            </div>
                            <div class="group_27 flex-row">
                                <div
                                        class="under_line flex-col"
                                        :style="{transform: `translateX(${underlinePosition}px)`, width: `${underlineWidth}px`}"
                                ></div>
                            </div>
                            <div class="group_36 flex-col">
                                <span class="text_65">{{ currentAdvantage.title }}</span>
                                <img
                                        class="image_17"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/home/chpc_about_line_02.png"
                                />
                                <div class="server_detail flex-col justify-between">
                                    <div class="text-wrapper_6">
                                        <template v-for="(line, i) in currentAdvantage.content">
                    <span :key="i" class="text_51">{{ line }} <br />
                    </span>
                                        </template>
                                    </div>
                                    <span class="text_57">{{ currentAdvantage.note }}</span>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeTab: 0,
                hoverTab: null,
                selectTab:0,
                serviceAdvantages: [
                    {
                        title: '经验优势',
                        content: [
                            '300+ 家 年均可疑商户走访量',
                            '900+ 份 年均HCO/CSO/DLR DD报告',
                            '7000+ 次 年均商业及终端执行量',
                            '8000+ 次 近3年走访经销商',
                            '超590+ 个 近3年执行要盖城市'
                        ],
                        note: '*上述“年均”概念以近3年企业实际数据统计获得'
                    },
                    {
                        title: '团队优势',
                        content: [
                            '100+资深核查团队',
                            '数十位源于行业的资深项目总监',
                            '核心团队成员拥有20年以上服务经验',
                            '项目总监拥有10年以上大型项目成功核查经验',
                        ],
                        note: null
                    },
                    {
                        title: '技术优势',
                        content: [
                            '创新产品数据分析系统',
                            '多种健康度评估模型',
                            '多样性的业务系统',
                            '人工智能工具集',
                        ],
                        note: null
                    },
                    {
                        title: '业务优势',
                        content: [
                            '10大中心支援全国业务',
                            '30+大型药械外企优选供应商',
                            '100+客户领域涵盖医药、器械、动保、人保、快消等',
                            '客户整体满意度达95%+',
                        ],
                        note: '*近三年客户项目及服务质量问卷调研整体满意度95分及以上约占8成。'
                    },
                    // 其他优势数据...
                ],
                underlineWidth: 40, // 默认下划线宽度
                tabElements: [], // 存储标签DOM元素
                tabPositions: [] // 存储标签位置
            };
        },
        computed: {
            currentTab() {
                return this.hoverTab !== null ? this.hoverTab : this.activeTab;
            },
            currentAdvantage() {
                return this.serviceAdvantages[this.activeTab];
            },
            underlinePosition() {
                if (this.tabElements.length > 0 && this.tabElements[this.currentTab]) {
                    const tab = this.tabElements[this.currentTab];
                    const container = tab.parentElement;
                    const containerRect = container.getBoundingClientRect();
                    const tabRect = tab.getBoundingClientRect();

                    // 计算相对于容器的位置
                    //return tabRect.left - containerRect.left;
                    // 计算位置时考虑宽度减少20px，需要居中
                    return (tabRect.left - containerRect.left) + 10; // 加10px使减少的宽度在两侧均匀分布
                }
                return 0;
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.calculateTabPositions();
            });
        },
        methods: {
            calculateTabPositions() {
                // 获取所有标签元素
                this.tabElements = this.serviceAdvantages.map((_, index) =>
                    this.$refs[`tab-${index}`][0]
                );

                // 设置初始下划线宽度
                if (this.tabElements[0]) {
                    //this.underlineWidth = this.tabElements[0].offsetWidth ;

                    this.underlineWidth = this.tabElements[0].offsetWidth -20;
                }
            },
            hoverIndexFun(index){
                this.hoverTab = index
                this.activeTab = index;
            },
            selectFun(index){
                this.activeTab =index;
                this.selectTab = index;
            },
            hoverOff(){
                this.hoverTab =null;
                this.activeTab = this.selectTab;
            }
        },
        watch: {
            currentTab(newVal) {
                if (this.tabElements[newVal]) {
                    //this.underlineWidth = this.tabElements[newVal].offsetWidth;
                    //计算位置时考虑宽度减少20px
                    this.underlineWidth = Math.max(0, this.tabElements[newVal].offsetWidth -20);
                }
            }
        }
    };
</script>
<style scoped lang="css" >
    .page_mobile_server {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        max-width: 1200px;
        justify-content: center;
        overflow: hidden;
        margin: 0 auto;
    }
    .div_server_wrap {
        width: 100%;
        max-width: 750px;

        margin: 0 auto;
        padding: 0 10px; /* 新增：添加左右内边距 */
        box-sizing: border-box; /* 新增：确保内边距不影响总宽度 */
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .text-group_10 {

    }

    .text_35 {
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 1.2;
        align-self: center;
    }

    .text_36 {
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 18px;
        text-align: center;
        white-space: nowrap;
        line-height: 1.2;
        margin-top: 6px;
    }

    .group_26 {
        background: url(../../../assets/home/chpc_about_mobile_server_03.png) no-repeat;
        background-size: 100% 350px; /* 限制背景图高度为350px */
        background-position: top; /* 背景图固定在顶部 */
        width: 100%;
        max-width: 700px;
        margin: 30px 0 0 1px;
        overflow: hidden;
    }

    .block_5 {
        width: 100%;
        max-width: 700px;
        min-height: 350px;
        background: url(../../../assets/home/chpc_about_mobile_server_02.png) no-repeat;
        background-size: 100% 350px; /* 限制背景图高度为350px */
        background-position: top; /* 背景图固定在顶部 */
        padding: 40px 0 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .text-wrapper_4 {
        display: flex;
        justify-content: center;
        position: relative;
        width: 100%;
        gap: 20px;
        /*flex-wrap: wrap;  允许标签换行 */
    }

    .text_active {
        cursor: pointer;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        letter-spacing: 0.034285712987184525px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 1.2;
        margin: 0px 0 0 10px;
        transition: color 0.3s;
    }

    .text_38 {
        cursor: pointer;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 0.6);
        font-size: 18px;
        letter-spacing: 0.034285712987184525px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 1.2;
        margin: 0px 0 0 1px;
        transition: color 0.3s;
    }
    .text_38, .text_active {
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        white-space: nowrap;
        padding: 0 5px;
    }

    .text_38:hover {
        color: rgba(255, 255, 255, 0.8);
    }


    .group_27 {
        position: relative;
        height: 5px;
        width: 100%;
        margin: 10px 0;
    }

    .under_line {
        position: absolute;
        height: 3px;
        background: white;
        bottom: 0;
        left: 0;
        transition: all 0.3s ease;
        will-change: transform, width;
    }

    .group_36 {
        width: 90%;
        max-width: 690px;
        background: url(../../../assets/home/chpc_about_mobile_server_01.png) center center no-repeat;
        background-size: cover;
        padding: 42px 61px 0 61px;
        margin: 20px auto 0;
        position: relative;
        z-index: 1;
        background: #FFFFFF;
        box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.2);
        box-sizing: border-box;
        /*min-height: 200px;*/
        display: flex; /* 添加flex布局 */
        flex-direction: column; /* 垂直排列子元素 */
    }

    .text_65 {
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 29px;
        letter-spacing: 0.041px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .image_17 {
        width: 40px;
        height: 1px;
        margin: 15px 510px 0 0;
    }


    .server_detail {
        width: 100%;
        max-width: 504px;
        margin: 10px 0 37px 0;
        flex-grow: 1;
    }

    .text-wrapper_6 {
        width: 100%;
        max-width: 550px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 1.5;
        height: auto;
    }

    .text_51 {
        width: 100%;
        max-width: 370px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 1.7;
        height: auto;
        flex-wrap: wrap;
    }

    .text_57 {
        width: 100%;
        max-width: 502px;
        height: auto;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        letter-spacing: 0.022px;
        text-align: left;
        white-space: nowrap;
        flex-wrap: wrap;
        line-height: 1.7;
        margin: 10px 0 0 2px;
    }

    @media (min-width: 391px) and (max-width: 650px) {
        .text-wrapper_4 {
            gap: 10px;
        }
        .text_35 {
            font-size: 25px;
        }
        .text_36 {
            font-size: 13px;
        }
        .text_65 {
            font-size: 16px;
        }
        .text_51 {
            font-size: 13px;
        }
        .text_57 {
            font-size: 10px;
        }
        .block_5 {
            min-height: 200px;
            background-size: 100% 200px;
            padding: 20px 0 20px 0;
        }
        .group_26 {
            min-height: 200px;
            background-size: 100% 200px; /* 限制背景图高度为350px */
        }

        .group_36 {
            width: 95%;
            padding: 20px 30px 0 30px;
            margin: 10px auto 0;
        }
        .image_17 {
            width: 40px;
            height: 1px;
            margin: 0px 0 0 0;
        }
    }

    @media (max-width: 390px) {
        .text_35 {
            font-size: 25px;
        }
        .text_36 {
            font-size: 13px;
        }
        .group_26 {
            background-size: 100% 200px; /* 限制背景图高度为350px */
            background-position: top; /* 背景图固定在顶部 */
            margin: 20px 0 0 1px;
        }

        .block_5 {
            min-height: 200px;
            background-size: 100% 200px;
            padding: 20px 0 20px 0;
        }
        .group_36 {
            width: 95%;
            padding: 20px 30px 0 30px;
            margin: 10px auto 0;
        }
        .image_17 {
            width: 40px;
            height: 1px;
            margin: 0px 510px 0 0;
        }
        .text_51 {
            font-size: 12px;
        }
        .text_57 {
            font-size: 10px;
        }
        .text_65 {
            overflow-wrap: break-word;
            font-size: 16px;
            font-weight: 600;
            text-align: left;
            white-space: nowrap;
            line-height: 1.5;
        }
        .text-wrapper_4 {
            gap: 1px;
            /*flex-wrap: wrap;  允许标签换行 */
        }

        .text_65 {
            font-size: 16px;
        }
        .text_51 {
            font-size: 11px;
        }

        .text_38, .text_active {
            font-size: 16px;
        }

    }

</style>
